import React from "react";

const FormRadio = ({register ,setTypeChange}) => {
  return (
  //  <div className="border-primary-blue flex border md:w-[57%]" >
  //                 <p className="text-primary-red px-5 py-2  border-l sm:!w-[33%]">
  //                ब्यवसायको प्रकार
  //                </p>
  //                <div className=" border-l-2 flex  border-primary-blue">
  //                <div onClick={companyTypeHandleA} className="cursor-pointer  border-primary-blue px-1 ml-2 flex items-center my-2 rounded-2xl gap-2  bg-red-500">
  //                <label htmlFor=""  className="text-white">एकल</label>
                  
  //               <div className={`${companyType===true?"bg-yellow-400":"bg-white"} rounded-full w-3 h-3 `}> </div>
  //                 </div>
  //                 <div onClick={companyTypeHandleB} className="cursor-pointer border-primary-blue px-1 ml-2 flex items-center my-2 rounded-2xl gap-2  bg-red-500 ">
  //                <label htmlFor=""  className="text-white">साझेदारी 
  //                 </label>
                  
  //                 <div className={`${companyType===false?"bg-yellow-400":"bg-white"} rounded-full w-3 h-3 `}> </div>
  //                 </div>
  //                 </div>
  //               </div>
    // <div className="flex w-full">
    //   <p className="border-primary-blue text-primary-red border p-2 text-lg font-bold">
    //     ब्यवसायको प्रकार
    //   </p>
    //   <div className="border-primary-blue flex p-2 text-primary-red border  text-base font-bold sm:text-lg">
    //     <td className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border  text-white">
    //       <label htmlFor="ekal">एकल </label>
    //       <input type="radio"
    //       //  name="radio-btn"
    //       className=""
    //       value="ekal"
    //       {...register("business_type", { required: false, })}
    //         id="ekal" />
    //     </td>
        
    //     <td className="border-primary-blue text-sm flex items-center gap-2 bg-primary-red rounded-full border-l p-1 text-white">
    //       <label htmlFor="bahul">साझेदारी </label>
    //       <input type="radio" name="radio-btn"
    //       value="bahul"
    //       {...register("business_type", { required: false, })}
          
    //       id="bahul" />
    //     </td>
    //   </tr>
    // </div>
    <div className="border-primary-blue flex border-2 md:w-[57%]" >
    <p className="text-primary-red font-Laila px-5 py-2 font-bold  border-l sm:!w-[33%]">
      ब्यवसायको प्रकार
    </p>
    <div className=" border-l-2 flex flex-wrap border-primary-blue">
      <div  onClick={()=>setTypeChange(true)} className="cursor-pointer cursor-pointer border-primary-blue px-1 ml-2 flex items-center my-2 rounded-2xl gap-2  bg-red-500">
        <label htmlFor="test1" className="text-white">एकल</label>
        <input
         value="ekal"
            {...register("business_type", { required: false, })}
        type="radio" name="a" id='test1' />
        {/* <div className={`${companyType === true ? "bg-yellow-400" : "bg-white"} rounded-full w-3 h-3 `}> </div> */}
      </div>
      <div onClick={()=>setTypeChange(false)} className="cursor-pointer border-primary-blue px-1 ml-2 flex items-center my-2 rounded-2xl gap-2  bg-red-500 ">
        <label htmlFor="test" className="text-white">साझेदारी
        </label>
        <input 
        value="bahul"
           {...register("business_type", { required: false, })}
        type="radio" name="a" id="test" />

        {/* <div className={`${companyType === false ? "bg-yellow-400" : "bg-white"} rounded-full w-3 h-3 `}> </div> */}
      </div>
    </div>
  </div>
  );
};

export default FormRadio;
